var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 38888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85957 9.89429C7.96362 9.89429 9.66929 8.17001 9.66929 6.043C9.66929 3.91599 7.96362 2.1917 5.85957 2.1917C3.75552 2.1917 2.04985 3.91599 2.04985 6.043C2.04985 8.17001 3.75552 9.89429 5.85957 9.89429ZM5.85957 11.4669C8.82274 11.4669 11.2249 9.03851 11.2249 6.043C11.2249 3.04749 8.82274 0.619141 5.85957 0.619141C2.89639 0.619141 0.494263 3.04749 0.494263 6.043C0.494263 9.03851 2.89639 11.4669 5.85957 11.4669Z",
    fill: "#454F5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.56803 9.09867C8.87181 8.79165 9.36428 8.79171 9.66799 9.09881L13.2522 12.7231C13.5559 13.0302 13.5558 13.528 13.252 13.8351C12.9482 14.1421 12.4558 14.142 12.1521 13.8349L8.56788 10.2106C8.26417 9.90353 8.26424 9.40569 8.56803 9.09867Z",
    fill: "#454F5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionSearch);
export default __webpack_public_path__ + "static/media/action-search.e4a3ac2f2903b896bcd3c727def8341a.svg";
export { ForwardRef as ReactComponent };